'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'tree';
var width = 448;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = 'M235.1 10.8L224 .3 212.9 10.8 68.9 148.4 64 153.2l0 6.8 0 16 0 16 16 0 29.2 0L35.9 277.6 32 282.1l0 5.9 0 16 0 16 16 0 29.2 0L3.9 405.6 0 410.1 0 416l0 16 0 16 16 0 128 0 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 128 0 16 0 0-16 0-16 0-5.9-3.9-4.5L370.8 320l29.2 0 16 0 0-16 0-16 0-5.9-3.9-4.5L338.8 192l29.2 0 16 0 0-16 0-16 0-6.8-4.9-4.7L235.1 10.8zM240 416l0-208 0-16-32 0 0 16 0 208-48 0-16 0L37.1 416l87.1-101.6L146.8 288 112 288l-42.9 0 87.1-101.6L178.8 160 144 160l-40.8 0L224 44.5 344.8 160 304 160l-34.8 0 22.6 26.4L378.9 288 336 288l-34.8 0 22.6 26.4L410.9 416 304 416l-16 0-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;